/*
 *  -----------------------------------------------------------------------
 *    <copyright file="field-definition-grid.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import ExpandableGrid from 'views/components/core/expandable/grid';

const FieldDefinitionGrid = ({ fields }: any) => (
    <ExpandableGrid
        customKey="fields"
        items={fields}
        showPager
        groupable={false}
        showFirstColumn={false}
        scrollable="scrollable"
        reorderable
        pageable={false}
        resizable
        addScroll
        options={{
            allowExcelExport: false,
            allowExpandCollapseAll: false,
            useFilterChips: true,
        }}
        columns={[
            {
                label: 'Table',
                field: 'dataType',
                minWidth: 200,
            },
            {
                label: 'Name',
                field: 'name',
                minWidth: 160,
            },
            {
                label: 'Description',
                field: 'description',
                minWidth: 190,
            },
            {
                label: 'Key',
                field: 'key',
                minWidth: 190,
            },
            {
                label: 'Data Type',
                field: 'fieldType',
                minWidth: 190,
            },
        ]}
    />
);

export default FieldDefinitionGrid;
